import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  CardText,
} from "reactstrap";
const SectionCard = ({ title, details }) => {
  const splitEntries = chunkArray(Object.entries(details), 2); // Diviser les paires clé-valeur en groupes de 2

  return (
    <>
      <Card className="mb-4">
        {title == "Audit" ? (
          <CardTitle tag="h5" style={{ paddingLeft: "10px", paddingTop: 10 }}>
            {title}
          </CardTitle>
        ) : (
          <CardTitle tag="h5">{title}</CardTitle>
        )}

        <CardBody>
          {splitEntries.map((pair, rowIndex) => (
            <Row key={rowIndex}>
              {pair.map(([key, value], colIndex) => (
                <Col sm="6" key={colIndex}>
                  <p className="mb-2">
                    <i style={{ color: "#9d9c9c" }}>
                      <span
                        style={{
                          display: "inline-block",
                          width: "9em",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {key} :
                      </span>
                    </i>
                    <span
                      style={{ whiteSpace: "nowrap", fontFamily: "sans-serif" }}
                    >
                      {renderValue(value)}
                    </span>
                  </p>
                </Col>
              ))}
            </Row>
          ))}
        </CardBody>
      </Card>
    </>
  );
};
const chunkArray = (arr, size) => {
  return Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size)
  );
};

const renderValue = (value) => {
  if (value == null) {
    return "";
  } else if (typeof value === "string" && value.trim() === "") {
    return "";
  } else if (value === "Validé") {
    return <span className="bg-success badge bg-secondary">{value}</span>;
  } else if (value === "En attente") {
    return <span className="bg-info badge bg-secondary">{value}</span>;
  } else {
    return value;
  }
};
export default SectionCard;
